import * as angular from 'angular';

import { ComponentDefinition, UserGroups } from '../../models';

class UserGroupsTableController implements angular.IComponentController {
    readonly isLoading: boolean;
    readonly userGroups: UserGroups[];

    static $inject = [];
}
  
  export const wtUserGroupsTable: ComponentDefinition = {
    componentId: 'wtUserGroupsTable',
    controller: UserGroupsTableController,
    template: require('./userGroupsTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        userGroups: '<',
        isLoading: '<?'

    }
};
